import React, {Component} from 'react';
import {  adminloadTP,  AuthenticatedUser, putToast, stopTimer, reviseTUser, getObject} from "../../../api";
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import TournamentPageTemplate from '../tournamentPageTemplate'
import Modal from 'react-responsive-modal';
import JSONInput from 'react-json-editor-ajrm';
import locale    from 'react-json-editor-ajrm/locale/en';
import {CSVLink} from "react-csv";
const moment = require("moment");

class TournamentAdminJudges extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;
        this.getTdProps = this.getTdProps.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.onLoginAs = this.onLoginAs.bind(this);
        this.buildCSV = this.buildCSV.bind(this);


        this.state = {
            loading: true,
            open: false,
            user: user,
            selectedTUser: "",
            selectedUserId: '',
            tData: {},
            pid: params.pid,
        }

    }

    loadTournamentPage = () => {       
        if (this.state.pid) {
            adminloadTP('dashboard', 'ejq', this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({tData: d2.tournamentPage, tUserData: d2.tUserData, loading: false});                    
                }
            });
        } else this.setState({ loading: false});
    };

    getTdProps(state, rowInfo, column) {
        if (rowInfo && rowInfo.row) {
            if (column.id === 'avatar') {
                return {
                    onClick: () => { 
                        this.props.history.push(`/pages/dashboard?uid=${rowInfo.original.userId}`)
                    }                                      
                }
            } else {
                return {
                    onClick: () => { 
                        rowInfo.original.avatar1 = undefined;
                        rowInfo.original.avatar = undefined;
                        getObject('tUser', rowInfo.original.id).then(d2 => {
                            if (d2 && d2.error) {
                                console.log(d2.error);
                            } else {
                                this.setState({
                                    selectedUserId: d2.userId, 
                                    selectedTUser: d2,
                                    open: true})                            
                                }                            
                        });
                    },
                    onMouseOver: (e) => {
                        this.setState({
                            selected: rowInfo.index
                        })
                    },
                    style: {
                        background: rowInfo.index === this.state.selected ? '#d3dacf' : 'white',
                        //color: rowInfo.index === this.state.selected ? 'white' : 'black'
                    }
                }
            }
        } else { return {} }
    }
    
    onTUserJsonChanged = (event) => {
        this.setState({ selectedTUser: event.json });
    }

    onLoginAs() {
        //const tUser = JSON.parse(this.state.selectedTUser);

    }

    onCloseModal(mode) {
        this.setState({ selectedUserId: null, selectedTUser: '', open: false });
        
        if (mode === true && this.state.selectedUserId && this.state.selectedTUser) {


            reviseTUser(JSON.parse(this.state.selectedTUser)).then(d2 => {
                if (!d2 || d2.error) {
                    console.log(d2 ? d2.error : "Error - no data");
                    putToast.error(d2 ? d2.error : "Error - no data");
                } else {
                    putToast.success(d2.message);
                    this.setState( {open: false }); 
                }
            }); 
        }
    }
    componentDidMount() {
        this.loadTournamentPage();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.match.params.pid !== this.props.match.params.pid) {
        }
    }

    getJudgeStatusColor(status) {
        switch(status.substring(0,3)) {
            case "Rea": return "font-success"
            case "Ava": return "font-warning"
            case "Set": return "font-danger"
            default: return "font-info"
        }
    }

    convertImage(buffer, mime) {        
        let TYPED_ARRAY = new Uint8Array(buffer.data);
        const STRING_CHAR = String.fromCharCode.apply(null, TYPED_ARRAY);
        let base64String = btoa(STRING_CHAR);
        const imageUrl = `data:${mime};base64,` + base64String.toString('base64');

        return imageUrl; 
    }

    buildCSV() {
        const currentRecords = this.reactTable.getResolvedState().sortedData;
        var data_to_download = []
        for (var index = 0; index < currentRecords.length; index++) {
            let record_to_download = {}
            for(var colIndex = 0; colIndex < this.columns.length ; colIndex ++) {
                record_to_download[this.columns[colIndex].Header] = currentRecords[index][this.columns[colIndex].accessor]
            }
            data_to_download.push(record_to_download)
        }

        this.setState({ dataToDownload: data_to_download}, () => {
            // click the CSVLink component to trigger the CSV download
            this.csvLink.link.click()
        })       
    }

    render(){
        if (this.state.loading) { return null; }
        else {
            stopTimer();      
            const { tData, open, user, tUserData } = this.state;

            this.columns=[{
                Header: 'Judge',
                accessor: 'displayname',
            },{
                Header: 'Status',
                accessor: 'status',
                Cell: props => <span className={this.getJudgeStatusColor(props.value)}>{props.value}</span>

            },{
                Header: 'Class',
                accessor: 'judgeClass',
            },{
                Header: 'Email',
                accessor: 'email',
            },{
                Header: 'Phone',
                accessor: 'phone',
            },{
                Header: 'Rounds',
                accessor: 'rounds',
            },{
                Header: 'Count',
                accessor: 'roundCount',
                filterMethod: (filter, row) => { return (row[filter.id] === filter.value) }
            }]

            return (
                <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} title2={`Judge List - ${user.displayname}`} title3=""
                bcTitle="Judge List" bcParents={[
                    {name: tData.title, url: `/pages/tournament/${tData._id}`},
                    {name: "Administration", url: `/tournament/admin/${tData._id}`},
                    {name: "Dashboard", url: `/tournament/admin/dashboard/${tData._id}`}
                ]}
            >              
                <div className="container-fluid">           
                    <div className="row">
                        <div className="col-sm-12">
                            <h3 style={{marginLeft: "20px", display: "inline"}}>Judges</h3>
                                <CSVLink style={{marginLeft: "20px", display: "inline"}}
                                    data={this.state.dataToDownload ? this.state.dataToDownload : ""}
                                    filename={`judges_${moment().format('YYYYMMDD_HHmmss')}.csv`}
                                    className="hidden"
                                    ref={(r) => this.csvLink = r}
                                    target="_blank"
                                />
                                <button style={{marginLeft: "20px", marginBottom: "6px", display: "inline"}} type="button" className="btn btn-primary" onClick={this.buildCSV}>Download</button>
                                
                                <ReactTable ref={(r) => this.reactTable = r}
                                filterable
                                defaultFilterMethod={ (filter, row, column) => {
                                    const id = filter.pivotId || filter.id
                                    return row[id] !== undefined ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase()) : true
                                }}
                                data={tUserData}
                                columns={this.columns}                                      
                                pageSize={(tUserData.length > 20) ? 20 : tUserData.length}
                                showPagination={(tUserData.length > 20)}                    
                                defaultPageSize={20}   
                                getTdProps={this.getTdProps}                                                                                                                                                                                                        
                            />
                        </div>
                    </div>  
                </div>
                <Modal open={open} onClose={this.onCloseModal} >
                    <div className="modal-header">
                        <h5 className="modal-title f-w-600" id="exampleModalLabel2">Edit Tournament User</h5>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-sm-10">  
                                <JSONInput
                                    id          = 'a_unique_id'
                                    locale      = { locale }
                                    height      = '550px'
                                    width       = '550px'
                                    placeholder = { this.state.selectedTUser ? this.state.selectedTUser  : [  { name: 'Home', link: '/' } ] }
                                    onChange = {this.onTUserJsonChanged}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" onClick={() => this.onLoginAs()}>Login As</button>
                        <button type="button" className="btn btn-primary" onClick={() => this.onCloseModal(true)}>Save</button>
                        <button type="button" className="btn btn-secondary" onClick={() => this.onCloseModal(false)}>Close</button>
                    </div>
                </Modal>  
                </TournamentPageTemplate>
            )
        }
    }
}

export default TournamentAdminJudges;